import { FormattedMessage } from "react-intl"

import MenuItem from "ds/MenuItem"

interface Props {
  onClick: React.MouseEventHandler<HTMLLIElement>
}

export default function MoveArgumentItem({ onClick }: Props) {
  return (
    <MenuItem onClick={onClick}>
      <FormattedMessage
        id="playbookEdit.argument.move"
        defaultMessage="Move to another tab"
      />
    </MenuItem>
  )
}
